var _g, _g2, _rect, _rect2, _rect3, _tspan, _rect4, _tspan2, _rect5, _rect6, _tspan3, _g3, _g4, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 300,
    viewBox: "0 0 132.29 79.375",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.992 0 0 .99329 .52917 .52917)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.29,
    height: 10.583,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.91 6.6869c-0.453 0.54855-1.139 0.8978-1.905 0.8978s-1.452-0.34925-1.905-0.8978c0.119-0.61825 0.534-1.1333 1.09-1.3917 0.231 0.16404 0.512 0.26106 0.815 0.26106s0.584-0.097016 0.815-0.26106c0.556 0.25841 0.971 0.77347 1.09 1.3917zm-1.905-1.3953c0.632 0 1.146-0.51416 1.146-1.1465s-0.514-1.1465-1.146-1.1465-1.146 0.51416-1.146 1.1465c0 0.63232 0.514 1.1465 1.146 1.1465zm2.646 0c0 1.459-1.187 2.6458-2.646 2.6458s-2.646-1.1868-2.646-2.6458c0-1.459 1.187-2.6458 2.646-2.6458s2.646 1.1868 2.646 2.6458zm-0.177 0c0-1.3617-1.107-2.4694-2.469-2.4694s-2.469 1.1077-2.469 2.4694c0 1.3617 1.107 2.4694 2.469 2.4694s2.469-1.1077 2.469-2.4694z",
    fill: "#fff",
    fillOpacity: 0.85,
    strokeWidth: 0.0047037
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.2917 2.1167a3.175 3.175 0 0 0-3.175 3.175 3.175 3.175 0 0 0 3.175 3.175 3.175 3.175 0 0 0 3.175-3.175 3.175 3.175 0 0 0-3.175-3.175zm-0.90711 1.6047h1.8143l0.90711 1.5711-0.90711 1.5711h-1.8143l-0.90711-1.5711z",
    fill: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.99598 0 0 .98565 .52917 .61007)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 10.583,
    width: 21.082,
    height: 68.792,
    fill: "#563bc4"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeOpacity: 0.25,
    strokeWidth: 0.23897
  }, /*#__PURE__*/React.createElement("path", {
    d: "m21.082 70.896h-21.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.082 62.297h-21.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.082 53.698h-21.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.082 45.099h-21.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.082 36.5h-21.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.082 27.901h-21.082"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.082 19.302h-21.082"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0364 0 0 1.0377 8.2285 10.391)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.187,
    y: 9.1937,
    width: 18.521,
    height: 3.7042,
    rx: 0.5106,
    ry: 0.50993,
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 61.462,
    y: 8.6832,
    width: 4.7215,
    height: 4.7252,
    rx: 0.5106,
    ry: 0.50993,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.35269,
    style: {
      fontVariationSettings: "normal"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4,
    y: 4.6021,
    width: 33.463,
    height: 2.7886,
    rx: 0.5106,
    ry: 0.50993,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("g", {
    strokeMiterlimit: 10
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.304,
    y: 19.82,
    width: 22.115,
    height: 4.7034,
    rx: 0.5106,
    ry: 0.50993,
    fill: "none",
    stroke: "#babfc3",
    strokeWidth: 0.3745
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 36.411816,
    y: 23.175316,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.2644px",
    letterSpacing: ".36271px",
    strokeWidth: 0.35944,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Nunito Sans 10pt'"
  }, "--/--/----"))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 63.853,
    y: 19.82,
    width: 22.115,
    height: 4.7034,
    rx: 0.5106,
    ry: 0.50993,
    fill: "none",
    stroke: "#babfc3",
    strokeWidth: 0.3745
  })), /*#__PURE__*/React.createElement("text", {
    className: "bday-p",
    x: 65.960999,
    y: 23.175316,
    fill: "#babfc3",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "3.2644px",
    letterSpacing: ".36271px",
    strokeWidth: 0.35944,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "'Nunito Sans 10pt'"
  }, "--/--/----")))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.22,
    y: 15.757,
    width: 16.732,
    height: 2.7886,
    rx: 0.5106,
    ry: 0.50993,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 34.248,
    y: 8.6544,
    width: 22.309,
    height: 4.7252,
    rx: 0.5106,
    ry: 0.50993,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.35269,
    style: {
      fontVariationSettings: "normal"
    }
  }), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.072,
    y: 4.6023,
    width: 12.549,
    height: 2.7886,
    rx: 0.5106,
    ry: 0.50993,
    fill: "#339cff"
  })), /*#__PURE__*/React.createElement("text", {
    x: 59.71373,
    y: 23.048544,
    fill: "#392781",
    fontFamily: "'Nunito Sans 10pt'",
    fontSize: "2.7886px",
    strokeMiterlimit: 10,
    strokeWidth: 0.27886,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 59.71373,
    y: 23.048544,
    fill: "#cccccc",
    fontSize: "2.7886px",
    strokeWidth: 0.27886
  }, "-"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.94425 0 0 .79508 20.444 10.839)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.4425,
    y: 21.22,
    width: 107.9,
    height: 44.598,
    rx: 1.0815,
    ry: 1.2827,
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.26452
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-5.4425 29.157h107.76",
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 0.26452
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -3.2969,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#0100ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 31.274,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#6766ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 31.274,
    width: 21.167,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffcb66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 31.274,
    width: 22.49,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#f66"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#33f"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffba33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 37.087,
    width: 15.875,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#f33"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#4c4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 42.899,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 48.712,
    width: 21.167,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#0200ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffa900"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 48.712,
    width: 18.521,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#f00"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#8080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 54.525,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffd480"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 54.525,
    width: 17.198,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ff8080"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -3.297,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#4d4cff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.015,
    y: 60.338,
    width: 15.875,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ffc34c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.326,
    y: 60.338,
    width: 19.844,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 23.028,
    width: 22.49,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 31.274,
    width: 19.981,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#8976d5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 37.087,
    width: 19.937,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#452f9d"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 42.899,
    width: 16.778,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#7862d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 48.712,
    width: 21.985,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#392781"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 54.525,
    width: 19.547,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#9b8adb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.284,
    y: 60.338,
    width: 17.574,
    height: 3.9688,
    rx: 1.5576,
    ry: 1.8474,
    fill: "#7862d0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.016978 0 0 .016978 11.331 1.3385)",
    fill: "#3d4193"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m878.91 798.85v199.64h-519.64v-754.55h160.24v39.516h199.15v-39.516h160.24v80.363c7.6367-0.72656 15.395-1.0898 23.152-1.0898 5.6953 0 11.395 0 16.969 0.60547v-119.88h-600v834.55h600v-239.15c-5.5742 0-11.273 0.72656-16.969 0.72656-7.7578 4e-3 -15.516-0.48438-23.152-1.2109z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 402.73v-79.516h-120v119.15h120zm-40 0h-40v-39.758h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.03 641.03v-79.516h-120v119.15h120zm-40 0h-40v-39.637h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m978.06 463.33-141.46 140.36-56.484-56.121-28.363 28.121 56.605 56.121 28.242 28.121 28.363-28.121 141.46-140.48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.03 800.06h-40v119.15h120v-119.15zm40 79.395h-40v-39.152h40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m619.03 184.67c5.1367-4e-3 10.07 1.9961 13.762 5.5703 3.6875 3.5742 5.8359 8.4453 5.9961 13.578h40c-0.9375-20.773-12.559-39.582-30.723-49.707s-40.273-10.125-58.438 0c-18.16 10.125-29.785 28.934-30.719 49.707h40.242c0.125-5.1641 2.2852-10.07 6.0039-13.656 3.7227-3.5859 8.707-5.5586 13.875-5.4922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m879.03 362.97c-52.633 0.28906-103 21.453-140.04 58.844s-57.734 87.953-57.531 140.59c0.20312 52.633 21.285 103.04 58.613 140.14 37.332 37.105 87.859 57.879 140.49 57.762 52.633-0.11719 103.07-21.117 140.23-58.387 37.164-37.27 58.023-87.766 57.992-140.4-0.2266-52.801-21.383-103.35-58.832-140.57-37.445-37.219-88.129-58.07-140.93-57.973zm0 357.33v4e-3c-42.051-0.28906-82.266-17.246-111.83-47.148-29.562-29.906-46.055-70.312-45.863-112.36 0.19141-42.051 17.055-82.305 46.891-111.94 29.836-29.633 70.207-46.219 112.25-46.125 42.051 0.0976 82.348 16.867 112.05 46.637 29.699 29.766 46.379 70.098 46.383 112.15-0.1602 42.254-17.094 82.711-47.07 112.49-29.98 29.773-70.555 46.43-112.81 46.301z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.969,
    y: 9.1937,
    width: 14.552,
    height: 3.7042,
    rx: 0.5106,
    ry: 0.50993,
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 90.283,
    y: 8.6832,
    width: 4.7215,
    height: 4.7252,
    rx: 0.5106,
    ry: 0.50993,
    fill: "none",
    stopColor: "#000000",
    stroke: "#babfc3",
    strokeMiterlimit: 10,
    strokeWidth: 0.35269,
    style: {
      fontVariationSettings: "normal"
    }
  }), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.623,
    y: 20.715,
    width: 13.229,
    height: 3.9688,
    rx: 0.7659,
    ry: 0.7649,
    fill: "#3d4193"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.66146,
    y: 0.66146,
    width: 130.97,
    height: 78.052,
    fill: "none",
    stroke: "#392781",
    strokeMiterlimit: 10,
    strokeWidth: 0.26458
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalApp);
export default __webpack_public_path__ + "static/media/internal-app.fe9f24e44c173f17e25ffdc10791a2a3.svg";
export { ForwardRef as ReactComponent };